<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/empresa/categorias'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de categorias"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-3">
              Aqui você poderá atualizar as informações da categoria, o que
              inclui modificar o título e o status da categoria. As categorias
              são vinculadas aos colaboradores e aos materias da trilha de
              qualificação, garantindo que os cursos sejam acessados apenas por
              colaboradores selecionados.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-9 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    <i class="fas fa-tags mr-2"></i> Categoria
                    <span class="text-warning">{{
                      model.categoria.title
                    }}</span>
                    <base-button
                      size="sm"
                      type="danger"
                      class="float-right"
                      @click="handleOpenModalRemove()"
                    >
                      <i class="fas fa-trash mr-1"></i> Deletar categoria
                    </base-button>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form role="form vld-parent" ref="categoria_form">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <base-input
                      label="Título da categoria*"
                      v-model.trim="model.categoria.title"
                      placeholder="Digite o nome título da categoria"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label d-block"
                      >Está ativa?
                      <i
                        class="fas fa-info-circle ml-1"
                        v-tooltip="
                          'Um categoria <b>ativa</b> fica visível para associação com cursos e colaboradores.'
                        "
                      ></i
                    ></label>
                    <base-input>
                      <base-switch
                        v-bind:value="model.categoria.is_active"
                        @input="switchChangedHandler($event)"
                      />
                    </base-input>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-12 text-center">
                    <base-alert type="danger" v-if="error">{{
                      error
                    }}</base-alert>
                    <base-alert type="success" v-if="success">{{
                      success
                    }}</base-alert>
                  </div>
                </div>
                <div class="text-center">
                  <base-button
                    type="primary"
                    class="mt-4"
                    :custom="true"
                    :disabled="!isValidModel"
                    @click="handleSubmitForm"
                    >Salvar alterações</base-button
                  >
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalRemove.show"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja
            <span class="text-danger">excluir a categoria</span>?
          </h4>
          <p class="my-3">
            Ao confirmar, a categoria "<b>{{ model.categoria.title }}</b
            >" será removida.
          </p>
        </div>
        <div class="col-12 text-center mt-3" v-if="modalRemove.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover a categoria. Tente
            novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modalRemove.show = false"
        >
          Voltar
        </base-button>
        <base-button type="white" class="text-danger" @click="handleRemove()">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "categoria-edit",
  data() {
    return {
      model: {
        categoria: {
          title: "",
          is_active: false
        }
      },
      error: "",
      success: "",
      modalRemove: {
        show: false,
        error: ""
      }
    };
  },
  async mounted() {
    const loaderForm = this.$loading.show({
      container: this.$refs.categoria_form,
      width: 90,
      height: 90
    });
    try {
      const { data } = await api.get(
        `/company/categories/${this.$route.params.id}`
      );
      data.is_active = Boolean(data.is_active);
      Object.assign(this.model.categoria, data);
      loaderForm.hide();
    } catch (e) {
      this.error = "Ocorreu um erro ao recuperar as informações da categoria.";
      this.$toasted.error("Erro ao recuperar as informações");
    }
  },
  methods: {
    async handleSubmitForm(e) {
      e.preventDefault();
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.categoria_form,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.put(
          `/company/categories/${this.$route.params.id}`,
          this.model.categoria
        );
        Object.assign(this.model.categoria, data);
        this.$toasted.show("Informações atualizadas com sucesso");
        this.success = "Categoria atualizada com sucesso!";
      } catch (e) {
        const genericError = "Ocorreu um erro ao salvar as informações";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData
          ? customError
          : "Não foi possível salvar as informações. Por favor, tente novamente em alguns instantes.";
        this.$toasted.error(genericError);
      }
      loader.hide();
    },
    switchChangedHandler(event) {
      if (typeof event === "boolean") this.model.categoria.is_active = event;
    },
    handleOpenModalRemove() {
      this.modalRemove.error = "";
      this.modalRemove.show = true;
    },
    async handleRemove() {
      this.modalRemove.error = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0
      });
      try {
        await api.delete(`/company/categories/${this.$route.params.id}`);
        this.$toasted.show("Caregoria removida com sucesso");
        this.modalRemove.show = false;
        this.$router.push("/empresa/categorias");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover a categoria");
        this.modalRemove.error = true;
      } finally {
        loader.hide();
      }
    }
  },
  computed: {
    isValidModel() {
      const categoria = this.model.categoria;
      if (categoria.title === "") return false;
      return true;
    }
  }
};
</script>
<style scoped></style>
